module.exports = __webpack_public_path__ + "img/waiter.d6dadd97.svg";